import axios from 'axios';
import { API_BASE } from '../config';

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

export const getFormSubjectsStatus = async (formId, params = {}) => {
  const res = await axios.get(`${API_BASE}forms/${formId}/subjects-status`, {
    ...authHeaders(),
    params,
  });
  return res.data;
};
